(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TaxStatusClass', TaxStatusClass);

    TaxStatusClass.$inject = ['$resource'];

    function TaxStatusClass ($resource) {
        var resourceUrl =  'api/tax-status-classes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
